module.exports = __webpack_public_path__ + "img/modal.527bfe67.svg";